import React, { useState } from 'react';

import { SideNavContext } from './SideNavContext';

export const SideNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [isSideNavOpen, setSideNavOpen] = useState(false);

	return (
		<SideNavContext.Provider value={{ isSideNavOpen, setSideNavOpen }}>
			{children}
		</SideNavContext.Provider>
	);
};
